import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getFunctions, httpsCallable, connectFunctionsEmulator } from 'firebase/functions';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyCB0wihCYou35187Bd_vpSj5q86uxsYgHA",
  authDomain: "vendorscout-58362.firebaseapp.com",
  projectId: "vendorscout-58362",
  storageBucket: "vendorscout-58362.firebasestorage.app",
  messagingSenderId: "924128652013",
  appId: "1:924128652013:web:3213be380d7df882887ae4",
  measurementId: "G-K215TGEBRQ"
};

const app = initializeApp(firebaseConfig);

// App Check - protects backend resources from abuse
// Debug token for localhost development
if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line no-restricted-globals
  self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}

initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider('6LfowEIsAAAAAMJwIpeXG6dsv8JNvNgL7JcP5PFW'),
  isTokenAutoRefreshEnabled: true
});

const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const googleProvider = new GoogleAuthProvider();
const functions = getFunctions(app);

// Analytics — only enabled in production (requires measurementId in Firebase console)
let analytics = null;
try {
  if (process.env.NODE_ENV !== 'development' || process.env.REACT_APP_USE_EMULATOR !== 'true') {
    analytics = getAnalytics(app);
  }
} catch {
  // Analytics not configured — silent fail
}

// Connect to local emulators when REACT_APP_USE_EMULATOR=true
if (process.env.REACT_APP_USE_EMULATOR === 'true') {
  connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
  connectFirestoreEmulator(db, 'localhost', 8080);
  connectStorageEmulator(storage, 'localhost', 9199);
  connectFunctionsEmulator(functions, 'localhost', 5001);
}

// Call this to check/set beta status on login
const checkBetaStatus = httpsCallable(functions, 'checkBetaStatus');

// Call this to refresh beta status for existing users added to beta list
const refreshBetaStatus = httpsCallable(functions, 'refreshBetaStatus');

// Admin functions
const addBetaUser = httpsCallable(functions, 'addBetaUser');
const removeBetaUser = httpsCallable(functions, 'removeBetaUser');
const getBetaUsers = httpsCallable(functions, 'getBetaUsers');
const getPendingQuotes = httpsCallable(functions, 'getPendingQuotes');
const reviewQuote = httpsCallable(functions, 'reviewQuote');

// Quote submission (anonymous)
const submitAnonymousQuote = httpsCallable(functions, 'submitAnonymousQuote');
const deleteQuoteFile = httpsCallable(functions, 'deleteQuoteFile');
const getQuoteDownloadUrl = httpsCallable(functions, 'getQuoteDownloadUrl');

export {
  auth,
  db,
  storage,
  googleProvider,
  functions,
  analytics,
  checkBetaStatus,
  refreshBetaStatus,
  addBetaUser,
  removeBetaUser,
  getBetaUsers,
  getPendingQuotes,
  reviewQuote,
  submitAnonymousQuote,
  deleteQuoteFile,
  getQuoteDownloadUrl
};
export default app;
